import { fadeInScaleUpTransition as t } from "../../../_styles/transitions/fade-in-scale-up.cssr.js";
import { fadeInTransition as i } from "../../../_styles/transitions/fade-in.cssr.js";
import { c as e, cB as o } from "../../../_utils/cssr/index.js";
import { DRAGGABLE_CLASS as r } from "../composables.js";
const d = e([o("modal-container", `
 position: fixed;
 left: 0;
 top: 0;
 height: 0;
 width: 0;
 display: flex;
 `), o("modal-mask", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background-color: rgba(0, 0, 0, .4);
 `, [i({
  enterDuration: ".25s",
  leaveDuration: ".25s",
  enterCubicBezier: "var(--n-bezier-ease-out)",
  leaveCubicBezier: "var(--n-bezier-ease-out)"
})]), o("modal-body-wrapper", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: visible;
 `, [o("modal-scroll-content", `
 min-height: 100%;
 display: flex;
 position: relative;
 `)]), o("modal", `
 position: relative;
 align-self: center;
 color: var(--n-text-color);
 margin: auto;
 box-shadow: var(--n-box-shadow);
 `, [t({
  duration: ".25s",
  enterScale: ".5"
}), e(`.${r}`, `
 cursor: move;
 user-select: none;
 `)])]);
export {
  d as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/modal/src/styles/index.cssr.js
// module id = 1720
// module chunks = 67